const parseJwt = token => {
  try {
    // Dividir el token por los puntos
    const base64Url = token.split('.')[1]

    // Reemplazar caracteres no URL-friendly y decodificar
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )

    return JSON.parse(jsonPayload)
  } catch (e) {
    console.error('Error decodificando el token:', e)

    return null
  }
}

const getTenantId = token => {
  const decodedToken = parseJwt(token)

  if (decodedToken) {
    return decodedToken.currentTenantId
  } else throw new Error('Error decodificando el token')
}

export default getTenantId
